import { useContext } from 'react';

import { isEmpty } from 'lodash';

import { UserAccessRestrictions } from '/types';
import { AppShellContext } from '/utils/contexts';

const useUserAccessRestrictions = (): UserAccessRestrictions => {
  const { accessDetails, userDetails } = useContext(AppShellContext);
  const mntl = accessDetails?.mntl;

  const userAccessRestrictions: UserAccessRestrictions = {
    downloadDisabled: true,
    isAcademicUser: false,
    isAnonymousUser: true,
    isLibraryLockdownUser: false,
    isMasquerading: false,
    isLoggedInUser: accessDetails !== undefined,
    toolsDisabled: true,
  };
  if (mntl) {
    userAccessRestrictions.isAcademicUser = !!mntl.is_academic;

    userAccessRestrictions.isAnonymousUser = !!mntl.anon;

    const numProducts = Object.values(mntl.access).filter(
      (access) => !isEmpty(access),
    ).length;
    userAccessRestrictions.toolsDisabled =
      userAccessRestrictions.isAnonymousUser ||
      (numProducts === 1 &&
        (mntl.access?.clients?.verticals || []).length === 0 &&
        (mntl.access?.clients?.single_copy || []).length > 0);

    userAccessRestrictions.isLibraryLockdownUser = !!mntl.access?.oxygen
      ?.library_lockdown;

    userAccessRestrictions.isMasquerading =
      !!userDetails?.email && !!mntl.mail && userDetails.email !== mntl.mail;

    userAccessRestrictions.downloadDisabled = !!mntl.access.gnpd
      ?.disable_downloads;
  }
  return userAccessRestrictions;
};

export default useUserAccessRestrictions;
